import { useState, useEffect } from 'react'

import { BsCheckLg } from 'react-icons/bs'
import { ImCross } from 'react-icons/im'

import { cme_kurs } from './Global/Kurs'
import { isOnServer } from './Global/constants'
import { formatDateToString } from './Global/functions'

import Question from './Question'
import Popup from './Popup'
import LoginHandler from './Login/LoginHandler'
import KursButton from './KursButton'



export const QuestionsContainer = () => {

    // -- raw answers
    const [rawAnswers, setRawAnswers] = useState(Array(10));

    // -- formated rawAnswers for backend
    const [answerKey, setAnswerKey] = useState("");



    //  -- set/get rawAnswers/answerKey in localstorage
    const rawAnswerKey = `rawAnswers${cme_kurs.kurs_key}`;
    const answerKeyLocalStoreKey = `answerKey${cme_kurs.kurs_key}`;

    useEffect(() => {
        const savedRawAnswers = window.localStorage.getItem(rawAnswerKey);
        if (savedRawAnswers) setRawAnswers(JSON.parse(savedRawAnswers));

        const savedAnswerKey = window.localStorage.getItem(answerKeyLocalStoreKey);
        if (savedAnswerKey) setAnswerKey(savedAnswerKey);
    }, [rawAnswerKey, answerKeyLocalStoreKey]);

    useEffect(() => {
        window.localStorage.setItem(rawAnswerKey, JSON.stringify(rawAnswers));
    }, [rawAnswers, rawAnswerKey]);
    useEffect(() => {
        window.localStorage.setItem(answerKeyLocalStoreKey, answerKey);
    }, [answerKey, answerKeyLocalStoreKey]);


    // -- render
    return (

        <div className="all-questions-container">

            {/* course title */}
            <div className="page-section--weiss">
                <div className="page-section-padding">
                    <div className="sectionTitel">
                        {cme_kurs.KursTitel}<br />
                        {(cme_kurs.KursUntertitel) ? <div className="sectionSubTitel">{cme_kurs.KursUntertitel}</div> : ""}
                    </div>
                </div>
            </div>

            {(isOnServer && cme_kurs.active) ?
                // login possible
                <>
                    <div className='page-section--hellgrau page-section-padding'>
                        <div><u>{cme_kurs.FragenTitel}</u></div>
                        <div>{cme_kurs.FragenVorgehen}</div>
                    </div>

                    <div className="page-section--rot">
                        <div className="page-section-padding">
                            <div className="text-klein-label text-weiss">{cme_kurs.EFNHinweis}</div>
                        </div>
                        <div className="page-section-legende">* {cme_kurs.EFNHinweisLegende}</div>
                    </div>
                </>
                :
                <div className="page-section--rot">
                    <div className="page-section-padding">

                        {cme_kurs.active ?
                            // course is offline
                            <div className="text-klein-label text-weiss">
                                {cme_kurs.AppOfflineHinweis}
                            </div>
                            :
                            // course is not active
                            <div className="text-klein text-weiss">
                                Die Bearbeitung der Wissensfragen ist derzeit leider nicht möglich. <br />
                                Die Wissensfragen können nur in dem Gültigkeitszeitraum: {formatDateToString(cme_kurs.Laufzeit_Start)} - {formatDateToString(cme_kurs.Laufzeit_Ende)} bearbeitet werden.
                            </div>
                        }

                    </div>
                </div>
            }

            {cme_kurs.Wissensfragen.map((question, index) => (

                <Question
                    key={`question-component-${index}`}
                    questionIndex={index}

                    headline={question.headline}
                    subheadline={question.subheadline}
                    question={question.question}
                    answers={question.answers}
                    legende={question.legende}

                    rawAnswers={rawAnswers} setRawAnswers={setRawAnswers}
                    setAnswerKey={setAnswerKey}
                />

            ))}


            {/* Login-handler */}
            <div className="answer-manager-container">

                {/* only display if answers can be sent on cmeassist */}
                {(isOnServer && cme_kurs.active)
                    ?
                    <>
                        {(!rawAnswers.includes(undefined) && !rawAnswers.includes(null))
                            ?
                            <div className="login-popup-container">
                                <Popup
                                    id={'login-popup'}
                                    popupContent={
                                        (togglePopup) =>
                                            <LoginHandler
                                                answerKey={answerKey}
                                                rawAnswers={rawAnswers}
                                                togglePopup={togglePopup}
                                            />
                                    }
                                    Button={
                                        <KursButton
                                            buttonName={"Antworten abgeben (Login)"}
                                            btnIcon={<BsCheckLg />}
                                            backgroundColor="green"
                                        />
                                    }
                                />
                            </div>
                            :
                            <>
                                <KursButton buttonName="Noch nicht alle Fragen beantwortet" btnIcon={<ImCross />} />
                            </>}
                    </>
                    :
                    <></>
                }

            </div >
        </div>
    )
}

export default QuestionsContainer